export const HISTORY_TEXT = {
    BUTTON: {
        ADD_SECTION: 'Додати секцію',
        PUBLISH: 'Опублікувати',
        TRANSLATE: 'Перекласти',
    },
    MESSAGE: {
        NO_SECTIONS_YET: 'Ще немає секцій',
        FAIL_TO_FETCH_SECTIONS: 'Виникла помилка, не вдалося завантажити секції',
        PUBLISH_SUCCESS: 'Зміни успішно опубліковано',
        PUBLISH_ERROR: 'Виникла помилка при публікації секцій',
        TRANSLATE_SUCCESS: 'Переклад опубліковано успішно',
        TRANSLATE_ERROR: 'Виникла помилка при збереженні перекладу',
    },
};
